/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcesemptyfeedback2Inputs */

const en_sourcesemptyfeedback2 = /** @type {(inputs: Sourcesemptyfeedback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything you tell the assistant in chat that ends up shaping the timeline shows up here. These are your statements — not legal evidence; the files above are.`)
};

const pt_sourcesemptyfeedback2 = /** @type {(inputs: Sourcesemptyfeedback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo o que disser ao assistente no chat e que venha a alterar a cronologia aparece aqui. São declarações suas — não são prova documental; os ficheiros acima é que são.`)
};

/**
* | output |
* | --- |
* | "Anything you tell the assistant in chat that ends up shaping the timeline shows up here. These are your statements — not legal evidence; the files above are." |
*
* @param {Sourcesemptyfeedback2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcesemptyfeedback2 = /** @type {((inputs?: Sourcesemptyfeedback2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcesemptyfeedback2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcesemptyfeedback2(inputs)
	return pt_sourcesemptyfeedback2(inputs)
});
export { sourcesemptyfeedback2 as "sourcesEmptyFeedback" }